// delivery-location.js
console.log("delivery-location.js carregado!");

/**
 * Preenche #shipping-location com cidade, usando:
 * 1) request.ip exposto pelo theme (window.customer_ip)
 * 2) fallback para ipapi.co via front-end
 * Mantém ajuste de fonte para caber em 2 linhas.
 */

function adjustFont() {
  const textDiv = document.getElementById('shipping-text');
  if (!textDiv) return;

  const computed = window.getComputedStyle(textDiv);
  const fontSizeBase = parseInt(computed.fontSize) || 13;
  textDiv.style.fontSize = fontSizeBase + 'px';

  const lineHeight = parseInt(computed.lineHeight) || Math.round(fontSizeBase * 1.2);
  const maxHeight = lineHeight * 2;
  let fontSize = fontSizeBase;

  while (textDiv.scrollHeight > maxHeight && fontSize > 10) {
    fontSize--;
    textDiv.style.fontSize = fontSize + 'px';
  }
}

function setLocationText(city, region) {
  const el = document.getElementById('shipping-location');
  if (!el) return;
  if (!city) {
    el.innerText = 'sua região';
  } else {
    el.innerText = region ? `${city}, ${region}` : city;
  }
  adjustFont();
}

// fetch com timeout
function fetchWithTimeout(url, options = {}, timeout = 4500) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  options.signal = controller.signal;
  return fetch(url, options).finally(() => clearTimeout(id));
}

// busca por ip (ipapi.co)
async function getLocationFromIP(ip) {
  try {
    const url = ip ? `https://ipapi.co/${ip}/json/` : 'https://ipapi.co/json/';
    const res = await fetchWithTimeout(url, { mode: 'cors' }, 4500);
    if (!res.ok) throw new Error('response not ok ' + res.status);
    const data = await res.json();
    if (!data || !data.city) throw new Error('no city in response');
    return { city: data.city, region: data.region_code || data.region || '' };
  } catch (err) {
    console.warn('[delivery-location] erro ao obter via IP:', err && err.message ? err.message : err);
    return null;
  }
}

// Execução principal
(async function() {
  // se estiver no editor do theme, mostra placeholder e sai (evita confusão)
  try {
    if ((window.Shopify && Shopify.designMode) || window.self !== window.top) {
      setLocationText('sua região (preview)', '');
      console.info('[delivery-location] modo preview/editor detectado, não executando fetch.');
      return;
    }
  } catch (e) { /* ignore */ }

  // 1) Tentar usar IP exposto via Liquid
  const exposedIP = window.customer_ip || null;
  if (exposedIP) {
    const loc = await getLocationFromIP(exposedIP);
    if (loc) {
      setLocationText(loc.city, loc.region);
      return;
    }
  }

  // 2) Fallback: tentar via ipapi.co sem ip específico
  const loc2 = await getLocationFromIP(null);
  if (loc2) {
    setLocationText(loc2.city, loc2.region);
    return;
  }

  // 3) Fallback final
  setLocationText(null, null);
})();
